import { useContext } from 'react'
import { Link, NavLink } from 'react-router-dom'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { OrdersContext, UserContext } from './Root';
import { links } from '../Router';



export default function Header() {
   const [user, setUser] = useContext(UserContext)
   const [orders] = useContext(OrdersContext)

   const myOrdersList = orders.find(o => o.user._id === user._id)?.orders?.filter(o => o.status !== 'Served') || []

   function connectUser(type) {
      switch (type) {
         case 'client':
            setUser({ table: 10, name: 'michael', type: 'client', _id: '111' })
            break;
         case 'host':
            setUser({ type: 'host' })
            break;
         default: break;
      }
   }


   return (
      <header className='container-fluid' >
         <Navbar bg="dark" expand="lg" style={{ minHeight: '60px' }} >
            <Container>

               <Navbar.Brand >
                  <Link to={'/'}>  <img src="/img/restaurant.svg" width={50} height={40} alt="logo" /></Link>
               </Navbar.Brand>

               <Navbar.Toggle aria-controls="basic-navbar-nav" style={{ border: 'none', outline: 'none' }} />
               <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="me-auto">
                     {links[0].children
                        .filter(l => !l.notAllow.includes(user?.type) || l.notInMenu)
                        .map(l =>
                           <li key={l.path} className="nav-item position-relative w-fit-content">
                              <NavLink to={l.path} className="nav-link">{l.text}
                                 {l.text.toLowerCase() === 'my orders' && <span className='position-absolute top-3 start-100 translate-middle badge rounded-pill bg-danger'>{myOrdersList.length}</span>}
                              </NavLink>
                           </li>
                        )}
                     {user.type === 'host' ?
                        <li onClick={() => connectUser('client')} className='btn btn-primary me-0 me-md-2 mb-3 mb-md-0 '> connect as client</li> :
                        <li onClick={() => connectUser('host')} className='btn btn-primary'> connect as host</li>}
                  </Nav>
               </Navbar.Collapse>

            </Container>
         </Navbar>
      </header>
   )
}
